import { atom } from 'recoil';

export const key = 'maxContentWidth';

export const initialState = null;

export const state = atom<number | undefined>({
    key,
    default: undefined,
});
